webpackJsonp([50],{

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getQuery */
/* harmony export (immutable) */ __webpack_exports__["a"] = getQueryNew;
/* harmony export (immutable) */ __webpack_exports__["b"] = xDeCode;
/**
 * 工具函数
 * created by xxh
 * 2018年08月31日
 */
var Base64 = __webpack_require__("xrTZ").Base64;
/**
 * 查找url参数中指定name的参数
 * @param {*} name
 */
function getQuery(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

/**
 * 查找url参数中指定name的参数 多个问号
 * @param {*} name
 */
function getQueryNew(name) {
  var reg = new RegExp(name + '=([^&]*)');
  //
  // var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var index = window.location.href.indexOf('?');
  var r = decodeURIComponent(window.location.href).substr(index, window.location.href.length).match(reg);
  // alert(decodeURIComponent(window.location.href).substr(index, window.location.href.length))
  // alert(r)
  if (r != null) {
    // return unescape(r[2])
    return unescape(r[1]);
  }
  return null;
}

/**
 * 优惠券解密
 * @param 加密参数
 */
function xDeCode(param) {
  if (param) {
    // 进行解密
    var Separator = 'lifaair';
    var str = Base64.decode(param);
    var finStr = str.replace(new RegExp(Separator, 'g'), ",");
    // 去除最后一位 ,
    finStr = finStr.substr(0, finStr.length - 1);
    return finStr;
  }
  return null;
}

/***/ }),

/***/ "60Ov":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Kxe6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("Z/aq")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (confirm_Component.exports);


/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("60Ov")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HJCa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kxe6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./src/router/index.js
var router = __webpack_require__("YaEn");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      haveTabber: false, // 是否有底部导航
      closeMenu: true
    };
  },

  watch: {
    $route: function $route(to) {
      this.closeMenu = true;
      var pathArr = ['/home', /*'/classify',*/ /*'/usercenter',*/'/login', '/register', '/receive'];
      console.log(pathArr.indexOf(to.path));
      if (pathArr.indexOf(to.path) !== -1) {
        this.haveTabber = true;
      } else {
        this.haveTabber = false;
      }
    }
  },
  methods: {
    // 移动悬浮菜单
    menuMove: function menuMove(e) {
      if (e.touches[0].clientX > 40 && e.touches[0].clientX < window.innerWidth - 5) {
        e.target.style.right = window.innerWidth - e.touches[0].clientX + 'px';
      }
      if (e.touches[0].clientY > 0 && e.touches[0].clientY < window.innerHeight - 40) {
        e.target.style.top = e.touches[0].clientY + 'px';
      }
      e.preventDefault();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  data: function data() {
    return {
      haveTabber: false, // 是否有底部导航
      closeMenu: true
    };
  },

  watch: {
    $route: function $route(to) {
      this.closeMenu = true;
      var pathArr = ['/home', /*'/classify',*/ /*'/usercenter',*/'/login', '/register', '/receive'];
      console.log(pathArr.indexOf(to.path));
      if (pathArr.indexOf(to.path) !== -1) {
        this.haveTabber = true;
      } else {
        this.haveTabber = false;
      }
    }
  },
  methods: {
    // 移动悬浮菜单
    menuMove: function menuMove(e) {
      if (e.touches[0].clientX > 40 && e.touches[0].clientX < window.innerWidth - 5) {
        e.target.style.right = window.innerWidth - e.touches[0].clientX + 'px';
      }
      if (e.touches[0].clientY > 0 && e.touches[0].clientY < window.innerHeight - 40) {
        e.target.style.top = e.touches[0].clientY + 'px';
      }
      e.preventDefault();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c045838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.haveTabber),expression:"!haveTabber"}],staticClass:"menuBtn",class:!_vm.closeMenu ? 'menuBtnOpen' : '',on:{"touchmove":function($event){_vm.menuMove($event)},"click":function($event){$event.stopPropagation();_vm.closeMenu = !_vm.closeMenu}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.haveTabber),expression:"!haveTabber"}],staticClass:"slide-menu",class:_vm.closeMenu ? 'closeMenu' : '',on:{"click":function($event){$event.stopPropagation();_vm.closeMenu = !_vm.closeMenu}}},[_c('div',[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("首页")])],1),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":"/classify"}},[_vm._v("全部商品")])],1),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":"/shoppingtrolley"}},[_vm._v("购物车")])],1),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":"/usercenter"}},[_vm._v("我的")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("kL31")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__("TIfe");

// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__("0xDb");

// EXTERNAL MODULE: ./src/api/other.js
var other = __webpack_require__("VPHD");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js
var wechat = __webpack_require__("n6Wb");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/lib-flexible/flexible.js
var flexible = __webpack_require__("sVYa");
var flexible_default = /*#__PURE__*/__webpack_require__.n(flexible);

// CONCATENATED MODULE: ./src/main.js




















vue_esm["a" /* default */].use(toast["a" /* default */], { position: 'top' });
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(wechat["a" /* default */]);
vue_esm["a" /* default */].use(plugins_confirm["a" /* default */]);
vue_esm["a" /* default */].use(router["a" /* default */]);
vue_esm["a" /* default */].use(ajax["a" /* default */]);

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;
router["a" /* default */].beforeEach(function (to, from, next) {

  try {
    window.localStorage.setItem('test', 'support localStorage');
    window.localStorage.getItem('test');
    console.log(window.localStorage.getItem('test'));
  } catch (error) {

    vue_esm["a" /* default */].$vux.confirm.show({
      title: '提示',
      content: '当前浏览器版本过低或禁用本地存储，请更换浏览器!',
      showCancelButton: false,
      showConfirmButton: false

    });
    return;
  }
  if (true) {

    console.log(navigator.userAgent);
    var agent = navigator.userAgent.toLowerCase();
    var curUri = window.location.href.indexOf('/weixin');

    if (agent.match(/MicroMessenger/i) == "micromessenger" && curUri == -1) {

      console.log('weixin');
      var uri = window.location.href.split('/wap')[0] + '/weixin' + window.location.href.split('/wap')[1];

      window.location.href = window.location.href.split('/wap')[0] + '/weixin' + window.location.href.split('/wap')[1];
      return;
    } else if (agent.match(/MicroMessenger/i) != "micromessenger" && window.location.href.indexOf('/wap/') == -1) {
      console.log('wap');
      var _uri = window.location.href.split('/weixin')[0] + '/wap' + window.location.href.split('/weixin')[1];

      window.location.href = window.location.href.split('/weixin')[0] + '/wap' + window.location.href.split('/weixin')[1];
      return;
    }

    var postData = {

      page: 'https://' + window.location.host + '/wap/index.html#' + to.fullPath
    };
    Object(other["a" /* pageView */])(postData).then(function (res) {
      if (res.data.errorcode === 0) {
        console.log('访问统计成功！');
      } else {
        console.log('\u8BBF\u95EE\u7EDF\u8BA1\u5931\u8D25' + res.data.errormsg);
      }
    }).catch(function (err) {
      console.log('访问统计失败');
    });
  }

  vue_esm["a" /* default */].$vux.loading.show();

  var shareid = Object(utils["a" /* getQueryNew */])('shareid');
  if (shareid) {

    var _postData = {
      linkid: shareid
    };

    Object(other["b" /* updateLinkID */])(_postData).then(function (res) {
      if (res.data.errorcode === 0) {} else {
        console.log('更新分享上家id失败');
      }

      init();
    }).catch(function (err) {
      console.log(err);
      next();
    });
  } else {
    init();
  }

  function init() {

    if (to.meta.requireLogin && localStorage.getItem('accountIsLogin') !== 'true') {

      next('/login');
      return;
    }

    var tokenStr = window.localStorage.getItem('token');
    var tokenJson = JSON.parse(tokenStr);
    var timestamp = Date.parse(new Date());
    var isLogin = window.localStorage.getItem('isLogin');
    console.log(!tokenJson);
    console.log(!isLogin);
    console.log(to.path !== '/author');

    if (!tokenJson) {

      Object(auth["b" /* getTokenSyn */])().then(function (res) {
        if (res.data.errorcode === 0) {

          var JsonObj = {
            token: res.data.data.token,
            time: res.data.data.expirestime
          };
          console.log('\u83B7\u53D6\u6210\u529F' + res.data.data.token);
          localStorage.setItem('token', stringify_default()(JsonObj));
          if (res.data.data.islogin === 1) {
            localStorage.setItem('isLogin', true);
            localStorage.setItem('shareid', res.data.data.shareid);
          } else {
            localStorage.setItem('isLogin', false);
            localStorage.setItem('shareid', res.data.data.shareid);
          }
          next();
        } else {
          vue_esm["a" /* default */].$vux.toast.text('获取token失败');

          next();
          console.log('重新获取失败');
        }
      }).catch(function (err) {
        vue_esm["a" /* default */].$vux.toast.text('获取token失败');

        next();
        console.log(err);
      });
      next();
      return false;
    } else if (tokenJson && timestamp + 200000 > tokenJson.time * 1000) {

      console.log('token过期重新获取');

      Object(auth["b" /* getTokenSyn */])().then(function (res) {
        if (res.data.errorcode === 0) {

          var JsonObj = {
            token: res.data.data.token,
            time: res.data.data.expirestime
          };
          console.log('\u83B7\u53D6\u6210\u529F' + res.data.data.token);
          localStorage.setItem('token', stringify_default()(JsonObj));
          if (res.data.data.islogin === 1) {
            localStorage.setItem('isLogin', true);
            localStorage.setItem('shareid', res.data.data.shareid);
          } else {
            localStorage.setItem('isLogin', false);
            localStorage.setItem('shareid', res.data.data.shareid);
          }
          next();
        } else {
          vue_esm["a" /* default */].$vux.toast.text('获取token失败');

          next();
          console.log('重新获取失败');
        }
      }).catch(function (err) {
        vue_esm["a" /* default */].$vux.toast.text('获取token失败');

        next();
        console.log(err);
      });
      return;
    } else if (tokenJson && to.path === '/login' && localStorage.getItem('accountIsLogin') === 'true') {
      console.log('已登录');
      next('/usercenter');
      return;
    } else if (to.path === '/login' || to.path === '/register') {

      console.log('\u8981\u53BB\u7684\u5730\u5740\uFF1A' + from.path);
      console.log(from);
      localStorage.setItem('beforeLoginPath', from.path);
      localStorage.setItem('beforeLoginQuery', stringify_default()(from.query));
      localStorage.setItem('beforeLoginFullpath', from.fullPath);
    }

    if (to.path === '/address' && from.path === '/confirmOrder') {
      localStorage.setItem('beforeConfirmPath', from.fullPath);
    }
    next();
  }
});
router["a" /* default */].afterEach(function (to, from, next) {

  vue_esm["a" /* default */].$vux.loading.hide();

  document.title = to.meta.title;
});
/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: router["a" /* default */],
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTokenSyn;
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* unused harmony export setToken */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);




var qs = __webpack_require__("mw3O"); // 序列化参数

var TokenKey = 'x-AuthToken';
// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: "https://m.lifa-air.cn" + '/?s=', // api的base_url
  timeout: 15000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});
// 同步
function getTokenSyn() {
  var tokenStr = window.localStorage.getItem('token');
  var tokenJson = JSON.parse(tokenStr);
  var postData = {
    AppID: "Wap",
    Secret: "WapSecret123",
    oldtoken: tokenJson ? tokenJson.token : ''
  };
  return service({
    url: "https://m.lifa-air.cn" + '/?s=/Api/System/getToken',
    method: 'post',
    data: qs.stringify(postData)
  });
}

// 读取本地token
function getToken() {
  var tokenStr = window.localStorage.getItem('token');
  var tokenJson = JSON.parse(tokenStr);
  var timestamp = Date.parse(new Date());
  if (tokenJson && timestamp + 200000 < tokenJson.time * 1000) {
    // 存在有效token
    console.log('本地有效token');
    console.log(tokenJson);
    return tokenJson.token;
  } else {
    // 校验token有效性
    var _tokenStr = window.localStorage.getItem('token');
    var _tokenJson = JSON.parse(_tokenStr);
    var _timestamp = Date.parse(new Date());
    if (_tokenJson && _timestamp + 200000 > _tokenJson.time * 1000) {
      console.log('避免多个请求时 反复请求token');
      getTokenSyn().then(function (res) {
        if (res.data.errorcode === 0) {
          // 处理数据
          var JsonObj = {
            token: res.data.data.token,
            time: res.data.data.expirestime
          };
          console.log('\u83B7\u53D6\u6210\u529F' + res.data.data.token);
          localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JsonObj));
          if (res.data.data.islogin === 1) {
            localStorage.setItem('isLogin', true);
            localStorage.setItem('shareid', res.data.data.shareid);
          } else {
            localStorage.setItem('isLogin', false);
            localStorage.setItem('shareid', res.data.data.shareid);
          }
          console.log('获取成功，继续');
          return res.data.data.token;
        } else {
          console.log('获取token错误');
        }
      }).catch(function (err) {
        console.log(err);
      });
    } else if (!_tokenJson) {
      console.log(window.localStorage.getItem('token'));
      getTokenSyn().then(function (res) {
        if (res.data.errorcode === 0) {
          // 处理数据
          var JsonObj = {
            token: res.data.data.token,
            time: res.data.data.expirestime
          };
          console.log('\u83B7\u53D6\u6210\u529F' + res.data.data.token);
          localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JsonObj));
          if (res.data.data.islogin === 1) {
            localStorage.setItem('isLogin', true);
            localStorage.setItem('shareid', res.data.data.shareid);
          } else {
            localStorage.setItem('isLogin', false);
            localStorage.setItem('shareid', res.data.data.shareid);
          }
          console.log('获取成功，继续');
          return res.data.data.token;
        } else {
          console.log('获取token错误');
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
}
function setToken(token, days) {
  return __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set(TokenKey, token, {
    expires: days
  });
}

// 退出登录移除所有本地记录 cookie localstrong等
function removeData() {
  localStorage.removeItem('isLogin');
  localStorage.removeItem('accountIsLogin');
  localStorage.removeItem('beforeLoginUrl');
  localStorage.removeItem('ShoppingCarStr');
  localStorage.removeItem('shareid');
  localStorage.removeItem('showMenu');
  localStorage.removeItem('beforeLoginFullpath');
  localStorage.removeItem('beforeLoginPath');
  // localStorage.removeItem('token')
  // return true
}

/***/ }),

/***/ "VPHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = uploadFile;
/* harmony export (immutable) */ __webpack_exports__["d"] = uploadWechatFile;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateLinkID;
/* harmony export (immutable) */ __webpack_exports__["a"] = pageView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/**
 * 其他api
 * create by xxh
 * 2018年09月06日
 */




var qs = __webpack_require__("mw3O"); // 序列化参数

/**
 *首次 微信授权获取token
 * @param {*} postData 参数对象
 */
function uploadFile(postData) {
  postData = postData || {};
  var token = Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* getToken */])();
  //   postData.token = token
  postData.append('token', token);
  console.log(postData);
  var config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
    // return axios.post('http://weixin.sealook.cn/shop/?s=/Api/System/uploadFile', postData, config)
  };return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://m.lifa-air.cn/?s=/Api/System/uploadFile', postData, config);
}

/**
 *上传微信图片
 * @param {*} postData 参数对象
 */
function uploadWechatFile(postData) {
  postData = postData || {};
  var token = Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* getToken */])();
  postData.token = token;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/Api/System/uploadWechatFile',
    method: 'post',
    data: qs.stringify(postData)
  });
}

/**
 * 更新分享商家
 * @param {*} postData 参数对象
 */
function updateLinkID(postData) {
  postData = postData || {};
  var token = Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* getToken */])();
  postData.token = token;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/Api/User/updateLinkID',
    method: 'post',
    data: qs.stringify(postData)
  });
}

/**
 * 访问统计
 * @param {*} postData 参数对象
 */
function pageView(postData) {
  postData = postData || {};
  var token = Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* getToken */])();
  postData.token = token;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/Api/Statistics/page_view',
    method: 'post',
    data: qs.stringify(postData)
  });
}

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    // component: () => import('@/views/home/index'),
    redirect: '/home'
  }, {
    path: '/home',
    name: 'homeIndex',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "KR8f"));
    },
    meta: {
      title: 'LIFAair官方商城'
    }
  }, {
    path: '/classify',
    name: 'classifyIndex',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "xMoO"));
    },
    meta: {
      title: '商品分类'
    }
  }, {
    path: '/classifyticket',
    name: 'classifyticket',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(__webpack_require__.bind(null, "ID6b"));
    },
    meta: {
      title: '优惠商品'
    }
  }, {
    path: '/login',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "T+/8"));
    },
    name: 'login',
    meta: {
      title: '登录'
    }
  }, {
    path: '/search',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, "Rv23"));
    },
    name: 'search',
    meta: {
      title: '搜索'
    }
  }, {
    path: '/register',
    name: 'register',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "bqOp"));
    },
    meta: {
      title: '注册'
    }
  }, {
    path: '/backPassword',
    name: 'backPassword',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "Q8Zu"));
    },
    meta: {
      title: '找回密码'
    }
  }, {
    path: '/editPassword',
    name: 'editPassword',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(__webpack_require__.bind(null, "nrXC"));
    },
    meta: {
      title: '修改密码'
    }
  }, {
    path: '/newProduct',
    name: 'newProduct',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, "QQKM"));
    },
    meta: {
      title: '新品预售'
    }
  }, {
    path: '/collage',
    name: 'collage',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, "5msz"));
    },
    meta: {
      title: '今日拼团'
    }
  }, {
    path: '/secKill',
    name: 'secKill',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, "qAuh"));
    },
    meta: {
      title: '秒杀活动'
    }
  }, {
    path: '/act/guaranteedact',
    name: 'guaranteedAct',
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "m9Tu"));
    },
    meta: {
      title: '延保服务活动'
    }
  }, {
    path: '/newPassword',
    name: 'newPassword',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(__webpack_require__.bind(null, "0kdz"));
    },
    meta: {
      title: '设置新密码'
    }
  }, {
    path: '/orderDetail',
    name: 'orderDetail',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "BY+7"));
    },
    meta: {
      title: '商品详情'
    }
  }, {
    path: '/receive',
    name: 'receive',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "0WzV"));
    },
    meta: {
      title: '优惠券',
      requireLogin: false // 是否需要登录才可使用该功能
    }
  }, {
    path: '/receiveCoupon',
    name: 'receiveCoupon',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "J+4w"));
    },
    meta: {
      title: '领取优惠券',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/trialOrder',
    name: 'trialOrder',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "wD92"));
    },
    meta: {
      title: '产品试用'
    }
  },
  // {
  //   path: '/gitshoppingCard',
  //   name: 'shoppingCard',
  //   component: () => import('@/views/shoppingCard/index'),
  //   meta: {
  //     title: '购物车'
  //   }
  // },
  {
    path: '/nowPay',
    name: 'nowPay',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "673j"));
    },
    meta: {
      title: '选择支付方式',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/confirmOrder',
    name: 'confirmOrder',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "99k0"));
    },
    meta: {
      title: '确认订单',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/invoice',
    name: 'invoice',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(__webpack_require__.bind(null, "aJch"));
    },
    meta: {
      title: '发票信息',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/coupon',
    name: 'coupon',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "Vk0n"));
    },
    meta: {
      title: '优惠券',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/user/coupon',
    name: 'mycoupon',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "AwQ0"));
    },
    meta: {
      title: '我的优惠券'
    }
  }, {
    path: '/myIntegral',
    name: 'myIntegral',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(__webpack_require__.bind(null, "sOtd"));
    },
    meta: {
      title: '我的积分'
    }
  }, {
    path: '/integralGet',
    name: 'integralGet',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(__webpack_require__.bind(null, "V8ad"));
    },
    meta: {
      title: '积分提现',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/userInfo',
    name: 'userInfo',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "eSIO"));
    },
    meta: {
      title: '会员资料'
    }
  }, {
    path: '/address',
    name: 'address',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "q8HX"));
    },
    meta: {
      title: '地址管理',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/addressNew',
    name: 'addressNew',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "B+E+"));
    },
    meta: {
      title: '新增地址',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/usercenter',
    name: 'userCenter',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "md3T"));
    },
    meta: {
      title: '会员中心',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/usercenter/myorder',
    name: 'myOrder',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(__webpack_require__.bind(null, "ipMH"));
    },
    meta: {
      title: '我的订单',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/usercenter/orderdetail',
    name: 'uc-orderDetail',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, "J9EG"));
    },
    meta: {
      title: '订单详情',
      requireLogin: true // 是否需要登录才可使用该功能
    }
  }, {
    path: '/usercenter/orderlogistics',
    name: 'uc-orderLogistics',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(__webpack_require__.bind(null, "ORBx"));
    },
    meta: {
      title: '订单跟踪'
    }
  }, {
    path: '/usercenter/refunds',
    name: 'uc-refunds',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(__webpack_require__.bind(null, "Dr6g"));
    },
    meta: {
      title: '申请退换货'
    }
  }, {
    path: '/usercenter/submitrefunds',
    name: 'uc-submitRefunds',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "ltD8"));
    },
    meta: {
      title: '退货退款'
    }
  }, {
    path: '/usercenter/refunddetail',
    name: 'uc-refundDetail',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, "gJry"));
    },
    meta: {
      title: '退款详情'
    }
  }, {
    path: '/usercenter/replace',
    name: 'uc-replace',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, "ElhA"));
    },
    meta: {
      title: '换货'
    }
  }, {
    path: '/usercenter/comments',
    name: 'uc-comments',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, "JCc8"));
    },
    meta: {
      title: '我的评价'
    }
  }, {
    path: '/usercenter/membership',
    name: 'membership ',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(__webpack_require__.bind(null, "IwKh"));
    },
    meta: {
      title: '会员权益'
    }
  }, {
    path: '/usercenter/commentsDetail',
    name: 'uc-commentsDetail',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(__webpack_require__.bind(null, "k3Ho"));
    },
    meta: {
      title: '用户评价'
    }
  }, {
    path: '/usercenter/submitcomments',
    name: 'uc-submitcomments',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "9BIL"));
    },
    meta: {
      title: '商品评价'
    }
  }, {
    path: '/usercenter/NewPassword',
    name: 'ucNewPassword',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "Q8Zu"));
    },
    meta: {
      title: '修改密码'
    }
  }, {
    path: '/cooperation',
    name: 'cooperation',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "7DzD"));
    },
    meta: {
      title: '合作商户注册'
    }
  }, {
    path: '/guarantee',
    name: 'guarantee',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(__webpack_require__.bind(null, "l2LN"));
    },
    meta: {
      title: '延保服务活动'
    }
  }, {
    path: '/usercenter/guaranteed',
    name: 'ucGuaranteed',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(__webpack_require__.bind(null, "VJkQ"));
    },
    meta: {
      title: '延保凭证'
    }
  }, {
    path: '/partner/index',
    name: 'partnerIndex',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(__webpack_require__.bind(null, "3Kv5"));
    },
    meta: {
      title: '合作商户'
    }
  }, {
    path: '/partner/apply',
    name: 'partnerApply',
    component: function component() {
      return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, "JVO7"));
    },
    meta: {
      title: '申请合作商户'
    }
  }, {
    path: '/shoppingtrolley',
    name: 'shoppingtrolley',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "c6Vo"));
    },
    meta: {
      title: '购物车',
      requireLogin: true
    }
  },
  // {
  //   path: '/author',
  //   name: 'author',
  //   component: () => import('@/views/auth/index.vue'),
  //   meta: {
  //     title: '首页'
  //   }
  // },
  {
    path: '/agree',
    name: 'agree',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(__webpack_require__.bind(null, "qFbt"));
    },
    meta: {
      title: '隐私协议'
    }
  }, {
    path: '/demo',
    name: 'demo',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "+RJ3"));
    },
    meta: {
      title: '自定义组件展示'
    }
  }, {
    path: '*',
    name: '404',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(__webpack_require__.bind(null, "thLP"));
    },
    meta: {
      title: 'Not Found'
    }
  }]
}));

/***/ }),

/***/ "Z/aq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kL31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("HJCa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vLgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__("TIfe");





// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "https://m.lifa-air.cn" + '/?s=', // api的base_url
  timeout: 15000 // 请求超时时间
});
// request拦截器
service.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// respone拦截器
service.interceptors.response.use(
// 10003
function (response) {
  /**
   * code 10003 未登录 跳转登录
   */
  var res = response.data;
  if (res.errorcode === 10003) {
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace({ path: '/login' });
    localStorage.setItem('accountIsLogin', false);
    return response;
  }
  if (res.errorcode === 10002) {
    // token 过期
    // this.$vux.toast.hide()
    response.data.errormsg = 'loading...';
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].go(0);
    return response;
  }
  return response;
},
// response => response,
function (error) {
  console.log('err' + error); // for debug
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.34c4f2d0aaa51ed6cf57.js